import LoginComponent from "../component/login/login";

function LoginPage() {
  return <LoginComponent />;
}
export default LoginPage;
